import { render, staticRenderFns } from "./GroupWeigh.vue?vue&type=template&id=184408bf"
import script from "./GroupWeigh.vue?vue&type=script&lang=ts"
export * from "./GroupWeigh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports